import gql from 'graphql-tag';

export default gql`
  fragment hubspotContactCreateActivityFragment on HubspotContactCreateActivity {
    hubspotContactId
    preleadContactFirstName
    preleadContactLastName
  }
`;
